'use client';

import * as React from 'react';

import {
  BULK_EDIT_CHECKBOX_PX,
  BULK_EDIT_HEADER_PX,
  BULK_EDIT_LEFT_PX,
  BULK_EDIT_PRODUCT_PX,
  BULK_EDIT_ROW_PX,
} from './bulk-edit-columns';

export type BulkEditLayoutVariant = 'default' | 'modal';

export interface BulkEditLayoutMetrics {
  rowPx: number;
  headerPx: number;
  checkboxPx: number;
  productPx: number;
  leftPx: number;
}

const DEFAULT_METRICS: BulkEditLayoutMetrics = {
  rowPx: BULK_EDIT_ROW_PX,
  headerPx: BULK_EDIT_HEADER_PX,
  checkboxPx: BULK_EDIT_CHECKBOX_PX,
  productPx: BULK_EDIT_PRODUCT_PX,
  leftPx: BULK_EDIT_LEFT_PX,
};

const MODAL_METRICS: BulkEditLayoutMetrics = DEFAULT_METRICS;

export function getBulkEditLayoutMetrics(variant: BulkEditLayoutVariant): BulkEditLayoutMetrics {
  return variant === 'modal' ? MODAL_METRICS : DEFAULT_METRICS;
}

const BulkEditLayoutContext = React.createContext<BulkEditLayoutMetrics>(DEFAULT_METRICS);

export function BulkEditLayoutProvider({
  variant,
  children,
}: {
  variant: BulkEditLayoutVariant;
  children: React.ReactNode;
}) {
  const metrics = React.useMemo(() => getBulkEditLayoutMetrics(variant), [variant]);
  return (
    <BulkEditLayoutContext.Provider value={metrics}>{children}</BulkEditLayoutContext.Provider>
  );
}

export function useBulkEditLayoutMetrics() {
  return React.useContext(BulkEditLayoutContext);
}
